import type { OneTimePrice } from './getOneTimePrice';

export type PriceDisplay = {
    values: number[];
    variant: 'primary' | 'disabled';
};

export const toPriceDisplay = ({ effectivePrice, regularPrice, isOnSale }: OneTimePrice): PriceDisplay => ({
    values: isOnSale ? [effectivePrice, regularPrice] : [effectivePrice],
    variant: isOnSale ? 'disabled' : 'primary',
});
